import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSidenavModule } from '@angular/material/sidenav';
import { Router, RouterModule } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import type { Observable } from 'rxjs';
import { type CarplusPerm, PERM, RbacService } from '../../../core/rbac';
import { MobileMenuService } from '../../../core/services/mobile-menu.service';

interface MenuItem {
  icon: string;
  labelKey: string;
  route: string;
  permission: CarplusPerm;
}

@Component({
  selector: 'app-left-menu',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    TranslocoPipe,
  ],
  templateUrl: './left-menu.component.html',
  styleUrl: './left-menu.component.scss',
})
export class LeftMenuComponent {
  private router = inject(Router);
  private mobileMenuService = inject(MobileMenuService);
  protected readonly rbac = inject(RbacService);

  mobileMenuOpen$: Observable<boolean> = this.mobileMenuService.mobileMenuOpen$;

  menuItems: MenuItem[] = [
    {
      icon: 'home',
      labelKey: 'menu.dashboard',
      route: '/dashboard',
      permission: PERM.menuDashboard,
    },
    {
      icon: 'people',
      labelKey: 'menu.customers',
      route: '/customers',
      permission: PERM.menuCustomers,
    },
    {
      icon: 'power',
      labelKey: 'menu.cogenerators',
      route: '/cogenerators',
      permission: PERM.menuChp,
    },
    {
      icon: 'campaign',
      labelKey: 'menu.carCampaigns',
      route: '/car-campaigns',
      permission: PERM.menuCampaigns,
    },
    {
      icon: 'factory',
      labelKey: 'menu.rawData',
      route: '/raw-data',
      permission: PERM.menuRawdata,
    },
    {
      icon: 'table_chart',
      labelKey: 'menu.dataMatrix',
      route: '/data-matrix',
      permission: PERM.menuData,
    },
    {
      icon: 'task_alt',
      labelKey: 'menu.dataValidation',
      route: '/data-validation-matrix',
      permission: PERM.menuDatavalidator,
    },
    {
      icon: 'bar_chart',
      labelKey: 'menu.dataCalculated',
      route: '/data-calculated-chart',
      permission: PERM.menuData,
    },
    {
      icon: 'bar_chart',
      labelKey: 'menu.rawData',
      route: '/data-raw-chart',
      permission: PERM.menuRawdata,
    },
    {
      icon: 'show_chart',
      labelKey: 'menu.monthlyMetrics',
      route: '/monthly-metrics-aggregation',
      permission: PERM.menuData,
    },
    {
      icon: 'assessment',
      labelKey: 'menu.chpRecap',
      route: '/chp-recap',
      permission: PERM.menuChp,
    },
    {
      icon: 'category',
      labelKey: 'menu.measureTypes',
      route: '/measure-types',
      permission: PERM.menuMeasure,
    },
    {
      icon: 'settings',
      labelKey: 'menu.cogeneratorConfig',
      route: '/cogenerator-config',
      permission: PERM.menuChpConfig,
    },
    {
      icon: 'functions',
      labelKey: 'menu.formulas',
      route: '/formulas',
      permission: PERM.menuFormula,
    },
    {
      icon: 'how_to_reg',
      // Riusa la chiave già introdotta dal registro approvatori invece di
      // duplicarne la traduzione sotto `menu.*`.
      labelKey: 'approvers.title',
      route: '/approvers',
      permission: PERM.approverRead,
    },
    {
      icon: 'approval',
      labelKey: 'approvalInbox.menu',
      route: '/approvals',
      permission: PERM.transitionRead,
    },
  ];

  onMenuItemClick(item: MenuItem): void {
    this.router.navigate([item.route]);
    this.mobileMenuService.closeMobileMenu();
  }
}
